import React from 'react';
import Snackbar from 'ui/molecules/Snackbar';

import {useMessageState, useMessageDispatch} from 'context/message-context';

const Message = () => {
  const {message, type, duration} = useMessageState();
  const {showMessage} = useMessageDispatch();

  const handleClose = (event, reason) => {
    if (reason === 'timeout') {
      showMessage({message: null});
    }
  };

  return (
    <Snackbar
      open={Boolean(message)}
      onClose={handleClose}
      message={message}
      type={type}
      autoHideDuration={duration}
    />
  );
};

export default Message;
